export const GradientArrowsDownUp = ({
  size = 32,
  className = ''
}: {
  size?: number;
  className?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 35"
      fill="none"
      aria-label="Gradient Arrows Down Up"
      role="img"
      className={className}
    >
      <path
        d="M14.7081 21.2923C14.801 21.3852 14.8748 21.4955 14.9251 21.6169C14.9754 21.7383 15.0013 21.8684 15.0013 21.9998C15.0013 22.1312 14.9754 22.2614 14.9251 22.3828C14.8748 22.5042 14.801 22.6144 14.7081 22.7073L10.7081 26.7073C10.6152 26.8003 10.5049 26.874 10.3835 26.9244C10.2621 26.9747 10.132 27.0006 10.0006 27.0006C9.86914 27.0006 9.73901 26.9747 9.61762 26.9244C9.49622 26.874 9.38593 26.8003 9.29306 26.7073L5.29306 22.7073C5.20015 22.6144 5.12645 22.5041 5.07616 22.3827C5.02588 22.2613 5 22.1312 5 21.9998C5 21.8684 5.02588 21.7383 5.07616 21.6169C5.12645 21.4955 5.20015 21.3852 5.29306 21.2923C5.4807 21.1047 5.73519 20.9993 6.00056 20.9993C6.13195 20.9993 6.26206 21.0251 6.38345 21.0754C6.50485 21.1257 6.61515 21.1994 6.70806 21.2923L9.00056 23.5861V5.99981C9.00056 5.73459 9.10591 5.48024 9.29345 5.2927C9.48099 5.10517 9.73534 4.99981 10.0006 4.99981C10.2658 4.99981 10.5201 5.10517 10.7077 5.2927C10.8952 5.48024 11.0006 5.73459 11.0006 5.99981V23.5861L13.2931 21.2923C13.3859 21.1993 13.4962 21.1256 13.6176 21.0752C13.739 21.0249 13.8691 20.999 14.0006 20.999C14.132 20.999 14.2621 21.0249 14.3835 21.0752C14.5049 21.1256 14.6152 21.1993 14.7081 21.2923ZM26.7081 9.29231L22.7081 5.29231C22.6152 5.19933 22.5049 5.12557 22.3835 5.07525C22.2621 5.02493 22.132 4.99902 22.0006 4.99902C21.8691 4.99902 21.739 5.02493 21.6176 5.07525C21.4962 5.12557 21.3859 5.19933 21.2931 5.29231L17.2931 9.29231C17.1054 9.47995 17 9.73445 17 9.99981C17 10.2652 17.1054 10.5197 17.2931 10.7073C17.4807 10.895 17.7352 11.0004 18.0006 11.0004C18.2659 11.0004 18.5204 10.895 18.7081 10.7073L21.0006 8.41356V25.9998C21.0006 26.265 21.1059 26.5194 21.2934 26.7069C21.481 26.8945 21.7353 26.9998 22.0006 26.9998C22.2658 26.9998 22.5201 26.8945 22.7077 26.7069C22.8952 26.5194 23.0006 26.265 23.0006 25.9998V8.41356L25.2931 10.7073C25.4807 10.895 25.7352 11.0004 26.0006 11.0004C26.2659 11.0004 26.5204 10.895 26.7081 10.7073C26.8957 10.5197 27.0011 10.2652 27.0011 9.99981C27.0011 9.73445 26.8957 9.47995 26.7081 9.29231Z"
        fill="url(#paint0_linear_4194_11675)"
      />
      <defs>
        <filter
          id="filter0_d_4194_11675"
          x="-4"
          y="0"
          width="40"
          height="40"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4194_11675" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4194_11675"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_4194_11675"
          x1="5"
          y1="4.99902"
          x2="27.1805"
          y2="5.18135"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#458FFF" />
          <stop offset="1" stopColor="#CF6AFF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
